import { DBServiceOptionsWithImagesAndValidation } from '../../../../types/dbService';
import { EntryProcedureModel } from '../../../../types/EntryProcedure';
import { ProcedureModel, ProcedurePayload } from '../../../../types/Procedures';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import EntryProcedure from '../../EntryProcedure';
import { getNormalizedProcedurePrice } from './procedureAdd';

export const prepareUpdateProcedure = ({
    procedureElement,
    payload,
}: {
    procedureElement: ProcedureModel;
    payload: Partial<ProcedurePayload>;
}) =>
    procedureElement.prepareUpdate((procedure) => {
        procedure.category = payload.category ?? procedureElement.category;
        procedure.name = payload.name ?? procedureElement.name;
        procedure.description =
            payload.description ?? procedureElement.description;
        procedure.price =
            payload.price !== undefined
                ? getNormalizedProcedurePrice(payload.price)
                : procedureElement.price || '0';
        procedure.available = payload.available ?? procedureElement.available;
        procedure.userId = procedureElement.userId;
        procedure.organisationId = procedureElement.organisationId;
    });

export const prepareUpdateEntryProcedures = async ({
    procedureId,
    procedureElement,
    payload,
    updateEntriesRelatedProceduresPrice,
    serviceOptions,
}: {
    procedureId: string;
    procedureElement: ProcedureModel;
    payload: Partial<ProcedurePayload>;
    updateEntriesRelatedProceduresPrice: boolean;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}): Promise<EntryProcedureModel[]> => {
    const entryProcedureService = new EntryProcedure(serviceOptions);
    const entryProcedures = await entryProcedureService.getByParam(
        'procedure_id',
        procedureId,
    );
    const entryProceduresToUpdate = await Promise.all(
        entryProcedures.map(async (entryProcedure) => {
            const entries = await entryProcedure.entries.fetch();

            if (entries.length === 0 || entries[0].invoiceId) return null;

            return entryProcedure.prepareUpdate((entryProc) => {
                entryProc.name = payload.name ?? procedureElement.name;

                if (updateEntriesRelatedProceduresPrice) {
                    entryProc.price =
                        payload.price !== undefined
                            ? getNormalizedProcedurePrice(payload.price)
                            : procedureElement.price || '0';
                }
            });
        }),
    );

    return entryProceduresToUpdate.filter(
        (entryProcedure): entryProcedure is EntryProcedureModel =>
            entryProcedure !== null,
    );
};

export const logUpdateProcedureActions = ({
    procedure,
    entryProceduresToUpdate,
    logDBAction,
    tableName,
}: {
    procedure: ProcedureModel;
    entryProceduresToUpdate: EntryProcedureModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update procedure',
        modelName: tableName,
        payload: procedure,
    });

    logDBAction({
        message: 'Update procedure - update entry procedures',
        modelName: tableName,
        payload: entryProceduresToUpdate,
    });
};
